// 组件类
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "rs-switch-input",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.scss"],
})
export class SwitchInputComponent implements OnInit {
  @Input() value;
  @Input() text;
  @Input() orientation: 'front' | 'behind' = 'front';
  @Input() disabled = false;
  @Input() error = false;

  @Output()
  valueChange = new EventEmitter();

  ngOnInit() {}
  onChange(event) {
    const value = event.checked;
    this.valueChange.emit(value);
  }
  onClick(){
    const value = !this.value;
    this.valueChange.emit(value);
  }
}
